/* eslint-disable no-unused-vars */
export default function defaultCellRenderer(props) {
  var cellData = props.cellData,
      columnData = props.columnData,
      rowData = props.rowData,
      rowIndex = props.rowIndex;

  if (cellData === null || cellData === undefined) {
    return '—';
  }

  return String(cellData);
}